import actions from '@/core/store/anuencia/documentos/actions.js'

export default {
	actions,
}
